import { ISkillSetFields } from './create-drill.interface';
import { pluralize, summarizeList } from '../../../lib/helpers/text.helpers';

// The Formik skillSet rows reduced to the server ISkillSet shape: only complete rows (a position
// AND a skill chosen) survive — drops the trailing in-progress "add" row and any blanks.
export const toServerSkillSets = (skillSets: ISkillSetFields[]): ISkillSet[] =>
  skillSets
    .filter((skillSet) => skillSet.positionIds.length && skillSet.skillIds.length)
    .map((skillSet) => ({
      positionIds: skillSet.positionIds.map((position) => position.value),
      skillIds: skillSet.skillIds.map((skill) => skill.value),
    }));

// Gate a skillSet removal that would orphan calibration videos: no dangling -> proceed silently;
// otherwise confirm with the user. Returns whether the removal should proceed.
export const shouldProceedWithSkillSetRemoval = (
  danglingFilenames: string[],
  terms: { metric: string; event: string },
  confirm: (message: string) => boolean = (message) => window.confirm(message),
): boolean => {
  if (!danglingFilenames.length) return true;

  const descriptor = pluralize(danglingFilenames.length, 'calibration video', 'calibration videos');
  const message =
    `Removing this ${terms.metric} set leaves ${danglingFilenames.length} ${descriptor} referencing a `
    + `${terms.metric.toLowerCase()} this ${terms.event.toLowerCase()} will no longer evaluate. `
    + `They won't be used until re-calibrated: ${summarizeList(danglingFilenames, 10)}. Remove anyway?`;
  return confirm(message);
};
